import React from "react";
import * as R from "ramda";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";

export const formGroup = {
    packageId: {value: ""},
    packageName: {value: "", mandatory: true},
    listCabang: {value: []},
    listVariant: {value: [], mandatory: true},
    packageAllCabang: {value: null},
    packageSpecificCabang: {value: null},
    packageStartDate: {value: null},
    packageEndDate: {value: null},
    packageGracePeriod: {value: null},
    packageHasGracePeriod: {value: false},
    listKSU: {value: []},
    listGift: {value: []},
    listOtherItem: {value: []},
    listPart: {value: []},
    status: {value: "ACTIVE"},
};

export const initialDataDetail = {
    category: null,
    kode: null,
    name: null,
    satuan: null,
    jumlah: null,
    saved: false,
}

export const tableColumns = {
    mainPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "packageId",
            label: "Paket ID",
        },
        {
            name: "packageName",
            label: "Nama Paket",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "listCabang",
            label: "Cabang Berlaku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "listVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{!R.isEmpty(val) ? val : "-"}</p>,
                sort: false,
            },
        },
        {
            name: "packageStartDate",
            label: "Tgl Mulai",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "packageEndDate",
            label: "Tgl Selesai",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "packageGracePeriod",
            label: "Grace Periode",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "packageHasGracePeriod",
            label: "No Periode",
            options: {
                customBodyRender: (val) => <p>{val ? "YA" : "TIDAK"}</p>,
                sort: false,
            },
        },
    ],
    detailPage: (
        handleSaveRow,
        handleEditRow,
        handleCancelRow,
        handleDeleteRow,
        handleValueChange,
        handleCategoryChange,
        handleItemChange,
        dataCategory,
        dataItem,
        tab,
    ) => {
        let column = [...defaultDetailColumns(
            "category",
            "kode",
            "name",
            "satuan",
            "jumlah",
            handleSaveRow,
            handleEditRow,
            handleCancelRow,
            handleDeleteRow,
            handleValueChange,
            handleCategoryChange,
            handleItemChange,
            dataCategory,
            dataItem,
            tab,
        )];
        return {
            KSU: column,
            Hadiah: column,
            OtherItem: column,
            Part: column,
        }
    },
}

const defaultDetailColumns = (
    category,
    kodeItem,
    nameItem,
    satuan,
    jumlah,
    handleSaveRow,
    handleEditRow,
    handleCancelRow,
    handleDeleteRow,
    handleValueChange,
    handleCategoryChange,
    handleItemChange,
    dataCategory,
    dataItem,
    tab,
) => {
    return [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: category,
            label: "Kategori*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return isSaved ?
                        <p>{val?.label}</p>
                        :
                        <SimpleDDL
                            id={`select_options_category_${tableMeta.rowIndex}`}
                            containerclassname="margin-bottom-none width width-200px"
                            name="category"
                            box="search"
                            menuPosition="fixed"
                            options={
                                dataCategory?.map(item => ({
                                    value: item.key,
                                    label: item.value
                                }))
                            }
                            value={val}
                            onChange={(value, {name}) => handleCategoryChange(tableMeta.rowIndex, name, value)}
                        />;
                },
                sort: false,
            },
        },
        {
            name: kodeItem,
            label: "Kode Item",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return isSaved ?
                        <p>{val}</p>
                        :
                        <SimpleInput
                            id="input_text_kodeKSU"
                            name="kodeKSU"
                            readOnly
                            containerclassname="margin-bottom-none width width-200px"
                            value={val}
                        />
                },
                sort: false,
            }
        },
        {
            name: nameItem,
            label: "Nama Item*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return isSaved ?
                        <p>{val?.label}</p>
                        :
                        <SimpleDDL
                            id={`select_options_category_${tableMeta.rowIndex}`}
                            containerclassname="margin-bottom-none width width-200px"
                            name="name"
                            box="search"
                            menuPosition="fixed"
                            value={val}
                            options={dataItem?.[tab]?.[tableMeta.rowIndex]}
                            onChange={(value, {name}) => handleItemChange(tableMeta.rowIndex, name, value)}
                        />;
                },
                sort: false,
            },
        },
        {
            name: satuan,
            label: "Satuan",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return isSaved ?
                        <p>{val}</p>
                        :
                        <SimpleInput
                            id="input_text_satuan"
                            name="satuan"
                            readOnly
                            containerclassname="margin-bottom-none width width-200px"
                            value={val}
                        />
                },
                sort: false,
            }
        },
        {
            name: jumlah,
            label: "Jumlah Item*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return isSaved ?
                        <p>{val}</p>
                        :
                        <SimpleInput
                            id="input_text_jumlah_item"
                            name="jumlah"
                            containerclassname="margin-bottom-none width width-100px"
                            box="onlyNumber"
                            value={val}
                            onChange={({target}) =>
                                handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                },
                sort: false,
            }
        },
        {
            name: "saved",
            label: "Action",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <FlexView vAlignContent="center" style={{gap: 10}}>
                            {
                                val ?
                                    <>
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={
                                                <i style={{fontSize: 20, color: "red"}}
                                                   className="fa fa-pencil-alt"
                                                />
                                            }
                                            onClick={() => handleEditRow(tableMeta.rowIndex)}
                                        />
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-times"/>}
                                            onClick={() => handleDeleteRow(tableMeta.rowIndex)}
                                        />
                                    </>
                                    :
                                    <>
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-times"/>}
                                            onClick={() => handleCancelRow(tableMeta.rowIndex)}
                                        />
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-save"/>}
                                            onClick={() => handleSaveRow(tableMeta.rowIndex)}
                                        />
                                    </>
                            }
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ]
};
